import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const content = css({
  inlineSize: Spacing.XS * 163,
})
